import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import Lottie from 'lottie-react-web';
import { Container, Row, Col, Button } from 'react-bootstrap';
import newsletter from 'assets/newsletter.svg';
import { postNewsletterAction } from 'services/actions/submit-newsletter';
import { useDispatch } from 'react-redux';
import luhn from 'luhn';
import amLoader from '../../assets/am-loader.json';

const NewsLetter = () => {
  const idNameInputNewsletter = 'exp-buy-nwl';
  const dispatch = useDispatch();
  const [newsletterState, setNewsletterState] = useState('');
  const { register, formState: { errors }, handleSubmit } = useForm({ mode: 'onChange' });
  const [account, setAccount] = useState('');
  const [errorMsg, setErrorMsg] = useState(null);
  const [isFeching, setIsFeching] = useState(false);

  const submitAccounntToNewsletter = async () => {
    setIsFeching(true);
    const formData = {
      accountNumber: account,
      code: 'YESEXP',
    };
    const response = await dispatch(postNewsletterAction(formData));
    const { status } = response.value;
    setErrorMsg('');

    if (status === 200) {
      setIsFeching(false);
      setAccount('');
      setNewsletterState('success');
    } else {
      setIsFeching(false);
      setNewsletterState('error');
    }

    if (status === 409) {
      setErrorMsg(response.value.message);
      setIsFeching(false);
      setNewsletterState('error');
    }
  };

  return (
    <Container fluid className="bg-color-hint-of-red newsletter">
      <Container>
        <Row className="justify-content-center py-60">
          <Col xs={12} lg={4} className="text-center d-none d-lg-block d-xl-block">
            <img src={newsletter} alt="icon-newsletter" />
          </Col>
          <Col xs={12} lg={8}>
            <h2 className="text-tangaroa py-15 ft-28">
              Suscripción
            </h2>
            <p className="text-tangaroa pb-15">
              Ingresa tu Número de Cuenta Aeroméxico Rewards,
              conoce nuestras Experiencias y Subastas antes que nadie.
            </p>
            {
              isFeching ? (
                <div className="loader-cp container">
                  <Lottie
                    width={50}
                    options={{
                      animationData: amLoader,
                    }} />
                </div>
              ) : (
                <form onSubmit={handleSubmit(submitAccounntToNewsletter)} className="header-group row">
                  <Col lg={6} className="pr-lg-0">
                    <div className="form-group mb-1">
                      {/* eslint-disable react/jsx-props-no-spreading */}
                      <input
                        {...register('account', {
                          required: true,
                          validate: { isAccount: (v) => luhn.validate(v) },
                          pattern: /[0-9]$/,
                          onChange: (e) => {
                            if (/[^0-9]/.test(e.target.value)) {
                              e.preventDefault();
                            } else {
                              setAccount(e.target.value);
                            }
                            setNewsletterState('');
                          },
                        })}
                        className="input-group-box input-newsletter text-tangaroa"
                        id={`${idNameInputNewsletter}-inp-sub}`}
                        name="account"
                        type="text"
                        value={account}
                        placeholder="Ingresa tu Número de Cuenta" />
                    </div>
                    {errors.account?.type === 'required' && <small className="error-msg text-dark-blue">* Campo requerido</small>}
                    {errors.account?.type === 'isAccount' && <small className="error-msg text-dark-blue">* Número de cuenta no válido</small>}
                    {errors.account?.type === 'pattern' && <small className="error-msg text-dark-blue">* Solo números</small>}
                    {newsletterState === 'success' && (
                      <small className="error-msg text-dark-blue">
                        <i className="fas fa-check mr-10" />
                        ¡Te has suscrito correctamente!
                      </small>
                    ) }
                    {newsletterState === 'error' && (
                      <small className="error-msg text-dark-blue">
                        <i className="fas fa-exclamation mr-10" />
                        { errorMsg ? `${errorMsg}` : 'Ocurrió un error con tu solicitud.' }
                      </small>
                    )}
                  </Col>
                  <Col lg={3} className="pl-lg-0">
                    <Button variant="primary" type="submit" className="btn br-btn-hide-left btn-submit">
                      Suscribirme
                    </Button>
                  </Col>
                </form>
              )
            }
          </Col>
          <Col xs={12} className="text-center d-lg-none d-xl-none pt-30">
            <img src={newsletter} alt="icon-newsletter" />
          </Col>
        </Row>
      </Container>

    </Container>
  );
};

export default NewsLetter;
